var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Create Forwarder ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-form",
              {
                staticClass: "pt-2",
                on: {
                  submit: function submit($event) {
                    $event.preventDefault()
                    return _vm.create($event)
                  }
                }
              },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-input-label", [_vm._v("Forward From")]),
                        _c(
                          "p",
                          {
                            staticClass: "body-2 mb-4"
                          },
                          [_vm._v(_vm._s(_vm.mailbox.email))]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("gg-text-field", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email",
                              expression: "'required|email'"
                            }
                          ],
                          attrs: {
                            outlined: "",
                            dense: "",
                            label: "Forward To",
                            placeholder: "ex. someone@example.com",
                            autocomplete: "off",
                            name: "Destination",
                            "error-messages": _vm.errors.collect("Destination")
                          },
                          model: {
                            value: _vm.destination,
                            callback: function callback($$v) {
                              _vm.destination = $$v
                            },
                            expression: "destination"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "pt-0",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "body-2 mb-0"
                          },
                          [
                            _vm._v(" A copy of every message to "),
                            _c("strong", [_vm._v(_vm._s(_vm.mailbox.email))]),
                            _vm._v(" will also be sent to "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.destination || "this address"))
                            ]),
                            _vm._v(". The mailbox keeps its own copy. ")
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.saving
                },
                on: {
                  click: _vm.create
                }
              },
              [_vm._v("Create Forwarder")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }